module.exports = __webpack_public_path__ + "/images/cover-hucha-inicio.0a7737d.jpg";